import React from 'react'
import { Link } from "react-router-dom";
import { useSelector } from "react-redux"
import "./About.css"
import Carousel from 'react-bootstrap/Carousel';
import tableDemo from "../../../Images/CryptoDemo.jpg"
import alertDemo1 from "../../../Images/AlertDemo1.jpg"
import alertDemo2 from "../../../Images/AlertDemo2.jpg"
import knowMore from "../../../Images/know-more.png"
import contactMail from "../../../Images/contactMail.png"

const About = () => {
    const auth = useSelector((state) => state.auth);
    const { isLogged } = auth;

    const handleSubscription = async e => {
        if(isLogged){
            window.location.href = "/profile";
        }
        else{
            window.location.href = "/register";
        }
    }
    
    return (
        <div className='about-page'>
            <div className='about-block'>
                <div className='about-left'>
                    <h3>Que Pouvons-Nous Offrir ?</h3>
                    <p>
                    Notre site web offre un suivi en temps réel des variations de cours de différentes crypto-monnaies en spot et dérivé, 
                    avec un taux de rafraîchissement inférieur à une seconde. Nous proposons également des <b>alertes sonores et par e-mail</b> pour vous informer 
                    des hausses et des baisses significatives, avec des périodes de calcul allant de <b>10 à 30 secondes</b>, puis 1 minute et au-delà.
                    </p>

                    <p>
                    Notre service est <b>gratuit pendant 14 jours</b>, puis devient payant sous forme d'abonnement mensuel <b>sans engagement</b>.
                    Nous ciblons principalement les investisseurs et traders de crypto-monnaies souhaitant être informés en temps réel 
                    des fluctuations du marché.                    
                    </p>
                </div>

                <Carousel className='about-right'>
                    <Carousel.Item>
                        <img className="d-block w-100" src={tableDemo} alt="First slide" />
                    </Carousel.Item>
                    <Carousel.Item>
                        <img className="d-block w-100" src={alertDemo1} alt="Second slide" />
                    </Carousel.Item>
                    <Carousel.Item>
                        <img className="d-block w-100" src={alertDemo2} alt="Third slide" />
                    </Carousel.Item>
                </Carousel>
                
            </div>

            <div className='about-block'>
                <div className='about-left illustration'>
                    <img src={knowMore} />
                </div>
                <div className='about-right'>
                    <h3>Qui Sommes-Nous ?</h3>
                    <p>
                    Notre équipe est composée de professionnels expérimentés dans le domaine des crypto-monnaies et de la technologie. 
                    Nous avons à coeur de fournir un service de qualité à nos clients et sommes toujours à l'écoute de leurs suggestions 
                    pour améliorer notre offre.
                    </p>

                    <p>
                    Nous travaillons en permanence à l'amélioration de notre site web et à l'ajout de 
                    nouvelles fonctionnalités pour répondre aux besoins de notre communauté. 
                    </p>                  
                </div>
            </div>

            {/* SUBSCRIPTION PLAN */}
            <div class="subscription-container about-subscription about-block">
                <div class="whole">
                    <div class="type">
                        <p>FREE</p>
                    </div>
                    <div class="plan">

                        <div class="header">
                            <span>€</span>0.00
                            <p class="month">per month</p>
                        </div>
                        <div class="content">
                            <ul>
                                <li>Données sur plus de 300 monnaies</li>
                                <li>Configurer jusqu'à 10 alertes</li>
                                <li>12 différents sons d'alerte</li>
                            </ul>
                        </div>
                        <div className="price free-plan">
                            <Link esxact to="/register" activeClassName="active" className="nav-links">
                                <p class="cart">Register</p>
                            </Link>                                
                        </div>
                    </div>
                </div>
                
                <div class="whole">
                    <div class="type standard">
                        <p>PREMIUM</p>
                    </div>
                    <div class="plan">

                        <div class="header">
                            <span>€</span>9.99
                            <p class="month">per month</p>
                        </div>
                        <div class="content">
                            <ul>
                                <li>Colonnes 10s, 20s et 30s</li>
                                <li>Notification par e-mail pour l'alerte</li>
                                <li>Service d'assistance </li>
                            </ul>
                        </div>
                        <div className="price start-free">
                            <a href="#" className="bottom" onClick={handleSubscription}> 
                                <p class="cart">Start a Free Trial</p>
                            </a> 
                        </div>
                    </div>
                </div>
            </div>

            <div className='about-block'>
                <div className='about-left illustration'>
                    <img src={contactMail} />
                </div>
                <div className='about-right'>
                    <h3>Contactez-Nous</h3>
                    <p>
                    Nous espérons que notre site web répondra à vos besoins en matière de suivi des variations de cours de crypto-monnaies et que vous nous accorderez votre confiance. 
                    N'hésitez pas à <span><a href="mailto:contact@iqscreener.com">nous contacter</a></span> pour toute question ou suggestion. 
                    </p>
                    <p>
                    Mail: <b>contact@iqscreener.com</b>          
                    </p>
                </div>
            </div>
        </div>
    )
}


export default About